import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bottom-bar bg-color-background-dark text-color-white flex flex-row flex-nowrap justify-between items-center h-16 fixed w-full bottom-0 left-0 z-10" }
const _hoisted_2 = { class: "logo ml-4" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "link-items flex flex-nowrap flex-row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "link mr-4" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://help.reprintsdesk.com/hc/en-us/requests/new",
      target: "_blank"
    }, "Help?")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _ctx.RSLogo,
        alt: "Research Solutions Logo"
      }, null, 8, _hoisted_3)
    ]),
    _hoisted_4
  ]))
}